var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7668 29.5337C22.9224 29.5337 29.5337 22.9224 29.5337 14.7668C29.5337 6.61134 22.9224 0 14.7668 0C6.61134 0 0 6.61134 0 14.7668C0 22.9224 6.61134 29.5337 14.7668 29.5337Z",
    fill: "#3A9AB8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_196_1087",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7668 29.5337C22.9224 29.5337 29.5337 22.9224 29.5337 14.7668C29.5337 6.61134 22.9224 0 14.7668 0C6.61134 0 0 6.61134 0 14.7668C0 22.9224 6.61134 29.5337 14.7668 29.5337Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_196_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3591 14.0012L15.3511 11.4063L19.3105 14.0173L15.3337 6.81543L11.3591 14.0012ZM11.5113 14.7506L15.3554 12.2175L19.1494 14.7318L15.3575 17.2677L11.5113 14.7506ZM11.3592 15.4759C12.7602 16.3946 14.2221 17.3563 15.3512 18.1004L19.3106 15.4759C17.8769 18.1058 16.6826 20.2951 15.3512 22.7181L14.5347 21.238C13.4379 19.25 12.3068 17.2 11.3592 15.4759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3347 6.81543L15.3496 11.4063L19.3104 14.0173L15.3347 6.81543ZM15.3531 12.2175L19.1722 14.7318L15.355 17.2677L15.3531 12.2175ZM15.3498 18.1004L19.3106 15.4759C18.0821 18.1058 15.3498 22.7181 15.3498 22.7181V18.1004Z",
    fill: "#BDBDBD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth-icon.554c2aa05d334b46f44d0ef654e0a479.svg";
export { ForwardRef as ReactComponent };